<!-- Back Navigation Warning Dialog -->
<ui-dialog
    deleteDialog
    (primaryButtonPressed)="goBack()"
    (secondaryButtonPressed)="closeDialog()"
    size="small"
    [open]="isWarningDialogOpen"
    [primaryButtonLabel]="'Discard'"
    header="Discard changes to Hiring Team"
    (closing)="closeDialog()"
>
    Your change to the Hiring Team will not be saved. Are you sure you want to discard?
</ui-dialog>

<!--Body-->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="" [back]="true"></app-header>
    <app-manage-hiring-team
        [employees]="employees"
        (selectionUpdated)="onHiringTeamUpdate($event)"
        (editAction)="onEdit = $event"
    ></app-manage-hiring-team>

    <ui-button style="float: right" [disabled]="!onEdit" type="primary" (click)="onSave()"> Save </ui-button>
</div>
